<template>
  <div>
    <div v-if="bootLoading" class="page-loading">
      <van-loading type="spinner" color="#1989fa" size="36px" />
    </div>

    <!-- 通用模板 -->
    <div v-else-if="showPage && shortUrlPageTemplate === 0" id="loginbox">
      <img
        src="@/assets/img/verifyV2/indexRx.png"
        v-if="+$route.query.imgType === 1"
      />
      <img v-else src="@/assets/img/verifyV2/post.png" />

      <van-form class="lform" ref="form" @submit="subSuccess">
        <van-field
          class="lform-input key"
          placeholder="请输入兑换码"
          v-model="form.redeemCode"
          :rules="[
            {
              required: true,
              message: '请输入兑换码'
            }
          ]"
        />
        <van-field
          class="lform-input phone"
          placeholder="请输入您本人手机号码"
          v-model="form.phone"
          name="phone"
          :rules="[
            {
              required: true,
              validator: val => /^1[3|4|5|6|7|8|9][0-9]{9}$/.test(val),
              message: '请填写正确的手机号'
            }
          ]"
        />
        <van-field
          class="lform-input yzm"
          placeholder="请输入验证码"
          v-model="form.code"
          :maxlength="6"
          :rules="[
            {
              required: true,
              validator: val => /^\d{6}$/.test(val),
              message: '请填写正确的验证码'
            }
          ]"
        >
          <template #button>
            <div class="cdown" v-if="!time" @click="sendCode">发送验证码</div>
            <van-count-down
              class="cdown"
              v-else
              :time="time"
              format="ss 秒"
              @finish="time = 0"
            />
          </template>
        </van-field>
        <van-button
          class="submit"
          :loading="loading"
          loading-text="兑换中..."
          native-type="submit"
        >
          前往兑换
        </van-button>
      </van-form>
      <div class="prompt">
        <div class="prompt-title">
          <img src="@/assets/img/YonghuiSync/tips.png" alt="" />
          <span class="text">兑换说明</span>
        </div>
        <div class="content">
          <p>1、输入兑换码，手机号码，获取验证码后点击兑换。</p>
          <p>2、请在有效期内使用，过期将无法使用，不退换不补偿。</p>
        </div>
      </div>
    </div>

    <!-- 互金模板 -->
    <div
      v-else-if="showPage && [1, 2].includes(shortUrlPageTemplate)"
      class="hujin-page"
    >
      <div class="hujin-top">
        <div class="hujin-badge">
          <img
            class="hujin-badge__logo hujin-badge__logo--mix"
            src="@/assets/img/hujin/badge-mix.svg"
            alt=""
          />
        </div>
        <h1 class="hujin-title">
          <span class="hujin-title__highlight">欢迎</span>使用
        </h1>
        <p class="hujin-subtitle">Welcome to use</p>
        <div class="hujin-deco">
          <span class="hujin-deco__line hujin-deco__line--left"></span>
          <span class="hujin-deco__star">☆</span>
          <span class="hujin-deco__line hujin-deco__line--right"></span>
        </div>
      </div>

      <div class="hujin-main">
        <van-form ref="form" class="hujin-form" @submit="subSuccess">
          <div class="hujin-field">
            <img
              class="hujin-field__icon"
              src="@/assets/img/hujin/icon-code.svg"
              alt=""
            />
            <van-field
              v-model="form.redeemCode"
              placeholder="请输入兑换码"
              :rules="[{ required: true, message: '请输入兑换码' }]"
              :border="false"
            />
          </div>
          <div class="hujin-field">
            <img
              class="hujin-field__icon"
              src="@/assets/img/hujin/icon-phone.svg"
              alt=""
            />
            <van-field
              v-model="form.phone"
              name="phone"
              placeholder="请输入您本人手机号码"
              :rules="[
                {
                  required: true,
                  validator: val => /^1[3|4|5|6|7|8|9][0-9]{9}$/.test(val),
                  message: '请填写正确的手机号'
                }
              ]"
              type="tel"
              :maxlength="11"
              :border="false"
            />
          </div>
          <div class="hujin-field hujin-field--captcha">
            <img
              class="hujin-field__icon"
              src="@/assets/img/hujin/icon-captcha.svg"
              alt=""
            />
            <van-field
              v-model="form.code"
              placeholder="请输入验证码"
              :maxlength="6"
              :rules="[
                {
                  required: true,
                  validator: val => /^\d{6}$/.test(val),
                  message: '请填写正确的验证码'
                }
              ]"
              type="number"
              :border="false"
            />
            <div class="hujin-captcha-extra">
              <span class="hujin-captcha-extra__divider"></span>
              <span
                v-if="!time"
                class="hujin-captcha-extra__btn"
                @click="sendCode"
              >
                获取验证码
              </span>
              <van-count-down
                v-else
                class="hujin-captcha-extra__btn"
                :time="time"
                format="ss 秒"
                @finish="time = 0"
              />
            </div>
          </div>
          <van-button
            class="hujin-submit-btn"
            :loading="loading"
            loading-text="兑换中..."
            native-type="submit"
          >
            立 即 兑 换
          </van-button>
        </van-form>
      </div>

      <div class="hujin-rules">
        <div class="hujin-rules__head">
          <div class="hujin-rules__icon-wrap">
            <img src="@/assets/img/hujin/icon-rule.svg" alt="" />
          </div>
          <span class="hujin-rules__title">兑换说明</span>
        </div>
        <ul class="verify-hujin-rule-list">
          <li>输入兑换码，手机号码，获取验证码后点击兑换；</li>
          <li>请在有效期内使用，过期将无法使用，不退换不补偿；</li>
        </ul>
      </div>
    </div>

    <!-- 已兑换提示弹窗 -->
    <div class="overlay" v-show="showDialog">
      <div class="center">
        <img src="@/assets/img/YonghuiSync/warm.png" />
        <h1>温馨提示</h1>
        <div>
          该兑换码已兑换，若需要查看已兑换的券码，请输入
          <span>首次兑换时的手机号码</span>
        </div>
        <button @click="showDialog = false">好的</button>
      </div>
    </div>
  </div>
</template>

<script>
import { Loading } from 'vant'
import {
  syncVerify,
  sendVerifyCode,
  checkForMixComboLink
} from '@/api/verifyV2.js'

export default {
  components: {
    [Loading.name]: Loading
  },
  data() {
    return {
      time: 0,
      loading: false,
      showDialog: false,
      bootLoading: false,
      showPage: true,
      shortUrlPageTemplate: 0,
      form: {
        redeemCode: undefined,
        phone: null,
        code: null
      },
      jumpTimer: null // 清除 timer ID
    }
  },
  mounted() {
    this.checkMixLink()
  },
  methods: {
    async subSuccess() {
      try {
        this.loading = true
        const { code, data, message } = await syncVerify(this.form)
        this.loading = false
        // 错误码  输入手机号和兑换手机号不同错误码1  系统繁忙错误码3  您的操作太频繁错误码4
        switch (code) {
          case 0:
            this.waitingToJump(data)
            break
          case 1:
            this.showDialog = true
            break
          default:
            this.$toast.fail({
              message: message
            })
            break
        }
      } catch (error) {
        this.loading = false
      }
    },
    // 异步兑换成功需要前端自己loading 3秒在跳到火爆界面刷新在到列表页,携带的token有5分钟时效
    waitingToJump(data) {
      this.loading = true
      const form = this.form
      const param = {
        redeemCode: form.redeemCode,
        phone: form.phone,
        token: data.token
      }
      // 无须loading立马跳转
      if (data.token.includes('fast_')) {
        this.navigateToVerifyList(param)
        return
      }
      this.jumpTimer = setTimeout(() => {
        this.navigateToVerifyList(param)
      }, 3000)
    },
    navigateToVerifyList(param) {
      this.loading = false
      this.$router.push({
        path: '/verifyV2List',
        query: param
      })
    },
    sendCode() {
      try {
        this.$refs.form.validate('phone').then(async () => {
          const form = this.form
          const { code, message } = await sendVerifyCode({
            phone: form.phone,
            redeemCode: form.redeemCode,
            domain: window.location.hostname,
            shortUrlPageTemplate: this.shortUrlPageTemplate
          })
          if (code === 0) {
            this.time = 60000
          } else {
            this.time = 0
            this.$toast.fail({
              message: message
            })
          }
        })
      } catch (error) {
        this.time = 0
        this.loading = false
      }
    },
    async checkMixLink() {
      // T1006014 混合套餐兑换码改造，支持链接形式
      // 如果链接携带兑换码密文则解密回填
      const cipherRedeemCode = this.$route.params?.code
      if (cipherRedeemCode && this.$route.name === 'mcl') {
        this.bootLoading = true
        this.showPage = false
        try {
          const { code, message, data } = await checkForMixComboLink({
            cipherRedeemCode
          })
          if (code === 0) {
            this.form.redeemCode = data.redeemCode
            if (data?.shortUrlPageTemplate != null) {
              this.shortUrlPageTemplate = Number(data.shortUrlPageTemplate)
            }
          } else if (code !== 4) {
            this.$toast.fail({
              message: message
            })
          }
        } finally {
          this.bootLoading = false
          this.showPage = true
        }
      }
    }
  },
  beforeDestroy() {
    if (this.jumpTimer) {
      clearTimeout(this.jumpTimer)
      this.jumpTimer = null
    }
  }
}
</script>

<style lang="less" scoped>
@import '~@/assets/style/YonghuiSync.less';
@import '~@/assets/style/hujinStyle.less';

.page-loading {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
}

.hujin-badge__logo--mix {
  width: 102px;
  height: 102px;
}

.hujin-submit-btn {
  display: block;
  width: 100%;
  height: 112px;
  line-height: 112px;
  padding: 0;
  text-align: center;
  font-size: 40px;
  font-weight: 700;
  letter-spacing: 8px;
  color: #fff;
  background: linear-gradient(90deg, #b88729 0%, #f1c040 100%);
  border: none;
  border-radius: 24px;

  &.van-button--loading {
    opacity: 0.85;
  }
}

.verify-hujin-rule-list {
  margin: 0;
  padding: 0;
  list-style: none;
  counter-reset: verify-hujin-rule;

  > li {
    position: relative;
    padding-left: 52px;
    margin-bottom: 22px;
    font-size: 24px;
    line-height: 42px;
    letter-spacing: 0.5px;
    color: #4a3800;
    counter-increment: verify-hujin-rule;

    &:last-child {
      margin-bottom: 0;
    }

    &::before {
      content: counter(verify-hujin-rule);
      position: absolute;
      left: 0;
      top: 4px;
      width: 36px;
      height: 36px;
      line-height: 36px;
      text-align: center;
      font-size: 20px;
      font-weight: 700;
      color: #9a7a10;
      background: rgba(201, 152, 10, 0.13);
      border: 2px solid rgba(201, 152, 10, 0.32);
      border-radius: 18px;
      box-sizing: border-box;
    }
  }
}

:deep(.yzm) {
  .van-field__control {
    width: auto;
    flex: 1;
  }
  .cdown {
    padding: 0 3.77vw;
  }
}
</style>
